import EsSummaryView, {type EsSummaryViewProps} from '@/pages/components/audit-program/e-section/EsSummaryView';
import {NS_PAGE, type NSummaryPage} from '@/pages/components/audit-program/n-section/constants';

export type NsSummaryViewProps = Omit<EsSummaryViewProps, 'page' | 'fallback' | 'refCode'> & {
    page: NSummaryPage;
    refCode?: string;
};

/** Ns — Summary sheet for provisions, contingent liabilities and financial commitments. */
export default function NsSummaryView({
    page,
    refCode = 'Ns',
    ...rest
}: NsSummaryViewProps) {
    return <EsSummaryView {...rest} page={page} fallback={NS_PAGE} refCode={refCode}/>;
}
